import ResultPage from '@/components/Result/index'
import { assetUrl } from '@/utils/asset-url'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Received Data',
			link: `/received-data`
		},
		{
			label: 'Request Data',
			link : `/received-data/request`,
		},
		{
			label: 'Fail',
			link: `/received-data/request/fail`
		}
	]

	return ResultPage({
		layoutHeaderTxt: "somethingWrong",
		layoutSubHeaderTxt: "somethingWrongRequestingMessage",
		layoutContentImgPath: assetUrl("/img/fail.png"),
		backBtnTxt: "tryAgain",
		defaultTitle: "requestData",
		nextLocation: '/received-data/request',
		breadcrumbs: breadcrumbItem,
	});
}
export default ShareDataSuccessPage
